import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output
} from '@angular/core';

@Directive({
  selector: '[appClickOutside]'
})
export class ClickOutsideDirective {
  // Classname to check if the clicked DOM element contains this classname or not
  @Input() className!: string;

  // When clicking outside of the DOM element this event is triggered
  @Output() clickOutside: EventEmitter<void> = new EventEmitter<void>();

  constructor(private readonly elementRef: ElementRef) {}

  /**
   * On click listener for the DOM HTML element and checks if the clicking is
   * done outside/inside that element. If its clicked outside and if the DOM element
   * contains the classname as provided, only then it will emit event clickOutside();
   *
   * @param {HTMLElement} targetElement
   */
  @HostListener('document:click', ['$event.target'])
  onClick = (targetElement: HTMLElement) => {
    const clickedInside: boolean = this.elementRef.nativeElement.contains(targetElement),
      classExist: boolean = targetElement.className.includes(this.className);

    !clickedInside && !classExist && this.clickOutside.emit();
  };
}
